import 'react'
import { Typography } from '@mui/material'
import React, { FC, ReactNode } from 'react'
import { SmallButton, VBox } from '../elements/basic-elements'
import { ErrorText } from '../elements/form-elements'

type PlaceholderProps = {
  icon?: string | ReactNode
  headline: string
  description?: string
  error?: string
  cta?: string
  onClick?: Function
  // Keeps long descriptions to a readable line length.
  descriptionMaxWidth?: number | string
}
const ContentPlaceholder: FC<PlaceholderProps> = ({
  icon,
  headline,
  description,
  error,
  cta,
  onClick,
  descriptionMaxWidth
}) => {
  return (
    <VBox height="100%" gap={2} justifyContent="center" alignItems="center" textAlign="center">
      {typeof icon === 'string' ? <img src={icon} /> : icon}
      <Typography variant="body1" color="textPrimary">
        {headline}
      </Typography>
      {(error || description) && error ? (
        <ErrorText textAlign="center" sx={{ overflowWrap: 'anywhere' }}>
          {error}
        </ErrorText>
      ) : (
        description && (
          <Typography
            variant="body2"
            color="textPrimary"
            sx={{ opacity: 0.5, maxWidth: descriptionMaxWidth }}
            textAlign="center"
          >
            {description}
          </Typography>
        )
      )}
      {cta && (
        <SmallButton
          variant="contained"
          color="primary"
          disableElevation
          onClick={() => onClick && onClick()}
        >
          {cta}
        </SmallButton>
      )}
    </VBox>
  )
}

export default ContentPlaceholder
